/**
 *
 * @param obj
 * @returns {string}
 */
export default obj => {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1]
}
